module.exports = __webpack_public_path__ + "static/media/ic-gallery.88ba5644.svg";